import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/**
 * @file Created on Wed Aug 22 2018
 * @author BPo
 */


import api from '../../api';
import { CONSTANTS } from '../../../constants';
import { CodebookItemConverter, jsonConversions } from '@logio/common-be-fe';
import { Inject } from '@logio/typescript-ioc';
/**
 * Code book restriction transport layer.
 */

export var CodeBookItemLayer =
/*#__PURE__*/
function () {
  function CodeBookItemLayer() {
    _classCallCheck(this, CodeBookItemLayer);
  }

  _createClass(CodeBookItemLayer, [{
    key: "loadLookup",

    /**
     * Load data from the sequential endpoint
     * @param lookup Postfix to the sequential path endpoint
     * @param elementId Id of the lookup element
     */
    value: function loadLookup(lookup) {
      var _this = this;

      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var findPromise = api("".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.CODEBOOK_LOOKUP).concat(lookup)).get({
        responseType: 'json',
        params: params
      }).then(function (response) {
        var codeBooks = [];
        (response.data.result || []).map(function (item) {
          codeBooks.push(_this.converter.toObject(item, jsonConversions));
        });
        return {
          lookup: lookup,
          codeBooks: codeBooks
        };
      });
      return findPromise;
    }
  }]);

  return CodeBookItemLayer;
}();

__decorate([Inject, __metadata("design:type", CodebookItemConverter)], CodeBookItemLayer.prototype, "converter", void 0);